import { ChangeDetectionStrategy, Component } from '@angular/core';
import { contactUsLinks } from '@app/dashboard/constants/dashboard.constants';

@Component({
    selector: 'app-contact-us-wrapper',
    templateUrl: `contact-us-wrapper.component.html`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsWrapperComponent {
    public contactUsLinks = contactUsLinks;

    constructor() {}
}
